const version = window.FRONT_VERSION
const global = {}

global.aha_padding = function(num, length) {
	return (Array(length).join('0') + num).slice(-length)
}


global.VueDomain = 'https://edu.kjt61.com'

global.StaticPath = global.VueDomain + '/static'
global.StaticImagePath = global.StaticPath + '/image/'


global.URL = {}
global.URL.jsDir = '/static/js/codegamer'
global.URL.jqueryDir = global.URL.jsDir + '/jquery/2.2.4'
global.URL.jqconsoleDir = global.URL.jsDir + '/jq-console/v2.13.2'
global.URL.editormdDir = '/static/editor.md'
global.URL.skulptDistDir = global.URL.jsDir + '/skulpt-dist/0.11.0'
global.URL.aceDistDir = global.URL.jsDir + '/ace-builds/src-noconflict'
global.URL.editormdStaticDir = '/static/js/editor.md'

global.URL.editormdJqueryMinJs = global.URL.jqueryDir + '/jquery.min.js?v=' + version
global.URL.jqconsole = global.URL.jqconsoleDir + '/jqconsole.js?v=' + version
global.URL.editormdMinJs = global.URL.editormdDir + '/editormd.min.js?v=' + version

global.URL.JsCppMin = '/static/c_parser/c_parser.es5.min.js?v=' + version
global.URL.skulptMin = global.URL.skulptDistDir + '/skulpt.min.js?v=' + version
global.URL.skulptStdlib = global.URL.skulptDistDir + '/skulpt-stdlib.js?v=' + version
global.URL.acejs = global.URL.aceDistDir + '/ace.min.js?v=' + version
global.URL.aceThemeJs = global.URL.aceDistDir + '/theme-cobalt.js?v=' + version
global.URL.acePythonModeJs = global.URL.aceDistDir + '/mode-python.js?v=' + version
global.URL.aceCppModeJs = global.URL.aceDistDir + '/mode-c_cpp.js?v=' + version
global.URL.aceJavaModeJs = global.URL.aceDistDir + '/mode-java.js?v=' + version
global.URL.acePascalModeJs = global.URL.aceDistDir + '/mode-pascal.js?v=' + version
global.URL.aceExtLanguageToolsJs = global.URL.aceDistDir + '/ext-language_tools.js?v=' + version
global.URL.editorcollapseJs = global.URL.editormdStaticDir + '/collapse.js?v=' + version
global.URL.editorBubbleJs = global.URL.editormdStaticDir + '/bubble.js?v=' + version

global.URL.codeaha25dDir = '/static/codeaha25d'
global.URL.codeaha25dHtml5Dir = global.URL.codeaha25dDir + '/publish/html5'
global.URL.codeaha25dPublicDir = global.URL.codeaha25dHtml5Dir + '/public'
global.URL.codeaha25dPublicJsDir = global.URL.codeaha25dPublicDir + '/views/default/js'
global.URL.codeaha25dHtml5Dir = global.URL.codeaha25dDir + '/publish/html5'
global.URL.codeaha25dGameMinJs = global.URL.codeaha25dHtml5Dir + '/game.min.js?v=' + version
global.URL.codeaha25dCodeahaManagerJs = global.URL.codeaha25dPublicJsDir + '/play/CodeahaManager.js?v=' + version
global.URL.codeaha25dLodashMinJs = global.URL.codeaha25dPublicJsDir + '/aether/lodash.min.js?v=' + version
global.URL.codeaha25dAetherMinJs = global.URL.codeaha25dPublicJsDir + '/aether/aether.min.js?v=' + version
global.URL.codeaha25dEsperMinJs = global.URL.codeaha25dPublicJsDir + '/esper/esper.min.js?v=' + version
global.URL.codeaha25dScratchBlocksDir = global.URL.codeaha25dPublicDir + '/views/default/js/scratch-blocks'
global.URL.codeaha25dScratchBlocksBlocklyCompressedVertical = global.URL.codeaha25dScratchBlocksDir + '/blockly_compressed_vertical.js?v=' + version
global.URL.codeaha25dScratchBlocksMessages = global.URL.codeaha25dScratchBlocksDir + '/msg/messages.js?v=' + version
global.URL.codeaha25dScratchBlocksScratchMessages = global.URL.codeaha25dScratchBlocksDir + '/msg/scratch_msgs.js?v=' + version
global.URL.codeaha25dScratchBlocksBlocksCompressed = global.URL.codeaha25dScratchBlocksDir + '/blocks_compressed.js?v=' + version
global.URL.codeaha25dScratchBlocksBlocksCompressedVertical = global.URL.codeaha25dScratchBlocksDir + '/blocks_compressed_vertical.js?v=' + version
global.URL.codeaha25dScratchBlocksPythonCompressed = global.URL.codeaha25dScratchBlocksDir + '/python_compressed.js?v=' + version
global.URL.codeaha25dScratchBlocksStorage = global.URL.codeaha25dScratchBlocksDir + '/storage/storage.js?v=' + version


global.img = function(path) {
	return `${global.StaticImagePath}${path}?v=${version}`
}

global.uuid = function() {
	const s = []
	const hexDigits = '0123456789abcdef'
	for (let i = 0; i < 36; i++) {
		s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
	}
	s[14] = '4'
	s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
	s[8] = s[13] = s[18] = s[23] = '-'
	return s.join('')
}

// HTML标签转义（< -> &lt;）
global.html2Escape = function(sHtml) {
	let temp = document.createElement('div');
	(temp.textContent != null) ? (temp.textContent = sHtml) : (temp.innerText = sHtml)
	const output = temp.innerHTML
	temp = null
	return output
}

// HTML标签反转义（&lt; -> <）
global.escape2Html = function(str) {
	let temp = document.createElement('div')
	temp.innerHTML = str
	const output = temp.innerText || temp.textContent
	temp = null
	return output
}


export default global
